import { DatePipe } from '@angular/common';
import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { getAppDateFormatPattern } from './format.util';

@Injectable({ providedIn: 'root' })
@Pipe({
    standalone: false,
    name: 'appDateFormat',
})export class AppDateFormatPipe implements PipeTransform {
    constructor(private readonly datePipe: DatePipe) {}

    transform(value: Date | string | number | null | undefined): string {
        if (value == null || value === '') {
            return '';
        }
        return this.datePipe.transform(value, getAppDateFormatPattern()) ?? '';
    }
}
